import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const HUNT_LINKS = [
  { label: "All Expeditions", to: "/expeditions" },
  { label: "Alaska", to: "/expeditions?region=alaska" },
  { label: "Africa", to: "/expeditions?region=africa" },
  { label: "Central Asia", to: "/expeditions?region=central-asia" },
  { label: "Montana & Lower 48", to: "/expeditions?region=lower-48" },
  { label: "Canada", to: "/expeditions?region=canada" },
];

const COMPANY_LINKS = [
  { label: "About", to: "/about" },
  { label: "The Process", to: "/process" },
  { label: "The Dispatch Circle", to: "/dispatch-circle" },
  { label: "Field Reports", to: "/journal" },
  { label: "Gallery", to: "/gallery" },
  { label: "For Outfitters", to: "/outfitters" },
];

export default function Footer() {
  return (
    <footer className="bg-carbon text-bone grain" data-testid="footer">
      {/* Main Footer */}
      <div className="container-dh py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-3 mb-6">
              <div className="h-10 w-10 rounded-full overflow-hidden flex-shrink-0" style={{ filter: "drop-shadow(0 1px 3px rgba(0,0,0,0.4))" }}>
                <img src="/logo.png" alt="Dispatch Hunts" className="h-full w-full object-cover" />
              </div>
              <div>
                <span className="font-display text-base font-bold text-bone">DISPATCH</span>
                <span className="font-display text-base font-bold text-brass">HUNTS</span>
              </div>
            </Link>
            <p className="text-bone/50 font-body text-sm leading-relaxed mb-8 max-w-xs">
              Private hunt advisory for serious sportsmen. Vetted outfitters. Real inventory. No surprises.
            </p>
            <div className="space-y-3 text-sm">
              <a href="tel:4065805366" className="flex items-center gap-3 text-bone/60 hover:text-brass transition-colors" data-testid="footer-phone">
                <Phone className="w-4 h-4 text-brass" /> 406-580-5366
              </a>
              <a href="mailto:matt@dispatchhunts.com" className="flex items-center gap-3 text-bone/60 hover:text-brass transition-colors" data-testid="footer-email">
                <Mail className="w-4 h-4 text-brass" /> matt@dispatchhunts.com
              </a>
              <div className="flex items-center gap-3 text-bone/40">
                <MapPin className="w-4 h-4 text-brass/60" /> Kalispell, Montana
              </div>
            </div>
          </div>

          {/* Expeditions Column */}
          <div>
            <h4 className="text-label text-brass mb-6">Expeditions</h4>
            <ul className="space-y-3">
              {HUNT_LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-bone/50 hover:text-bone text-sm font-body transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 className="text-label text-brass mb-6">Company</h4>
            <ul className="space-y-3">
              {COMPANY_LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-bone/50 hover:text-bone text-sm font-body transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA Column */}
          <div>
            <h4 className="text-label text-brass mb-6">Start Here</h4>
            <p className="text-bone/50 text-sm font-body leading-relaxed mb-6">
              Ready to talk about your next hunt? Apply for a consultation and we'll be in touch.
            </p>
            <Link to="/apply" className="btn-brass w-full text-center !text-xs" data-testid="footer-apply-btn">
              Apply for a Consultation
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-bone/10">
        <div className="container-dh py-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-bone/30 text-xs font-body">
          <p>&copy; {new Date().getFullYear()} Dispatch Hunts. Kalispell, Montana.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="hover:text-bone/60 transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-bone/60 transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
